import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const RotateIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M5.66667 4H8C10.7613 4 13 6.23867 13 9C13 11.7613 10.7613 14 8 14C5.23867 14 3 11.7613 3 9C3 8.17333 3.20067 7.39333 3.556 6.70667"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.66666 2L5.66666 4L7.66666 6"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export default RotateIcon;
